import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-19011530"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "guide-comp"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pointer"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "arrow"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "line"
})], -1));
import { computed, inject, nextTick, reactive, ref, watchEffect } from 'vue';
import { useStore } from 'vuex';
import { CircleClose } from '@element-plus/icons-vue';
// ********************(基本参数)********************

export default {
  __name: 'guide',
  setup(__props) {
    const $store = useStore();
    // 用户信息
    const userInfo = computed(() => $store.state.userInfo);
    // 路由菜单
    const routesMenu = computed(() => $store.state.fpRoutes);
    // 用户信息和路由菜单是否都存在（依据此判断页面是否准备完毕）
    const applicationReady = computed(() => userInfo.value && routesMenu.value && routesMenu.value.length > 0);
    // 侧边栏实例
    const sidebarRef = inject('sidebarRef', null);
    // console.log('guide-comp', routesMenu, sidebarRef, sidebarRef.value.open)

    // ********************(指南组件状态)********************
    const guideStatus = ref(false);
    // 指南信息
    const guideInfo = reactive({
      // 指南文案
      text: '',
      // 按钮文案
      btnText: '',
      // 是否存在下一步
      next: false,
      // 下一步数据源
      nextSign: '',
      // 指南位置
      x: 0,
      y: 0,
      // 矩形信息
      rect: {
        left: 0,
        top: 0,
        width: 0,
        height: 0
      }
    });
    // 设置指南信息
    function setGuideInfo(info) {
      Object.assign(guideInfo, info);
    }
    // 下一步/知道了
    function nextStep() {
      if (guideInfo.next) {
        // console.log('nextStep', guideInfo.nextSign)
        setGuideInfo(guideInfo.nextSign);
      } else {
        closeEvent();
      }
    }
    // 关闭指南
    function closeEvent() {
      Object.assign(guideInfo, {
        text: '',
        btnText: '',
        next: false,
        nextSign: '',
        x: 0,
        y: 0,
        rect: {
          left: 0,
          top: 0,
          width: 0,
          height: 0
        }
      });
      guideStatus.value = false;
      localStorage.setItem('wp_loginSuccess', '0');
    }

    // ********************(品牌信息配置权限)********************
    // 是否拥有品牌信息配置权限
    const brandInfoConfigPermission = computed(() => $store.getters.checkFunctionalPermission('pms:brand_info_config'));
    // 是否拥有报告信息配置权限
    const reportDefinePermission = computed(() => $store.getters.checkFunctionalPermission('pms:report_define'));
    // 是否拥有企业端配置权限
    const enterpriseConfigPermission = computed(() => $store.getters.checkFunctionalPermission('pms:configuration_info'));

    // ********************(品牌信息配置权限指南)********************
    // 报告信息权限指南信息
    const reportDefineInfo = reactive({
      text: '原"报告自定义"配置项已经挪到这里，之后可通过这里配置~',
      btnText: '下一步',
      next: false,
      nextSign: '',
      x: 0,
      y: 0,
      rect: {
        left: 0,
        top: 0,
        width: 0,
        height: 0
      }
    });
    // 企业端配置权限指南信息
    const enterpriseConfigInfo = reactive({
      text: '原"信息配置"内容已经挪到这里，之后可通过这里配置~',
      btnText: '知道了',
      next: false,
      nextSign: '',
      x: 0,
      y: 0,
      rect: {
        left: 0,
        top: 0,
        width: 0,
        height: 0
      }
    });
    // 打开品牌信息配置菜单
    function openBrandInfoMenu() {
      if (sidebarRef.value && typeof sidebarRef.value.open == 'function') {
        // 品牌信息配置索引位置
        const brandInfoMenu = routesMenu.value.find(item => item.code == 'pms:brand_info_config');
        if (brandInfoMenu) {
          // console.log('brandInfoMenu', brandInfoMenu)
          sidebarRef.value.open(brandInfoMenu.path);
          // 确定指南位置
          nextTick(() => submenuElementRect());
        }
      }
    }
    // 定位品牌信息其下子菜单位置
    function submenuElementRect() {
      let reportDefineRect = '';
      let enterpriseConfigRect = '';
      if (reportDefinePermission.value) {
        const reportDefineElem = document.getElementById('pms:report_define');
        if (reportDefineElem) {
          const rdRect = reportDefineElem.getBoundingClientRect();
          // console.log('reportDefineElem', [reportDefineElem], rdRect)
          reportDefineRect = {
            x: rdRect.right,
            y: rdRect.top + rdRect.height / 2,
            rect: {
              left: rdRect.left,
              top: rdRect.top,
              width: rdRect.width,
              height: rdRect.height
            }
          };
          Object.assign(reportDefineInfo, reportDefineRect);
        }
      }
      if (enterpriseConfigPermission.value) {
        const enterpriseConfigElem = document.getElementById('pms:configuration_info');
        if (enterpriseConfigElem) {
          const ecRect = enterpriseConfigElem.getBoundingClientRect();
          // console.log('enterpriseConfigElem', [enterpriseConfigElem], ecRect)
          enterpriseConfigRect = {
            x: ecRect.right,
            y: ecRect.top + ecRect.height / 2,
            rect: {
              left: ecRect.left,
              top: ecRect.top,
              width: ecRect.width,
              height: ecRect.height
            }
          };
          Object.assign(enterpriseConfigInfo, enterpriseConfigRect);
        }
      }
      // 是否获取到报告信息配置菜单位置
      if (reportDefineRect) {
        // 是否获取到企业端配置权限
        if (enterpriseConfigRect) {
          reportDefineInfo.next = true;
          reportDefineInfo.btnText = '下一步(1)';
          reportDefineInfo.nextSign = enterpriseConfigInfo;
        } else {
          reportDefineInfo.next = false;
          reportDefineInfo.btnText = '知道了';
          reportDefineInfo.nextSign = '';
        }
      }
      // 设置指南信息
      if (reportDefineRect) {
        setGuideInfo(reportDefineInfo);
        // 打开指南
        guideStatus.value = true;
      } else if (enterpriseConfigRect) {
        setGuideInfo(enterpriseConfigInfo);
        // 打开指南
        guideStatus.value = true;
      }
    }
    // 时间范围内
    function inTimeRange(endDate) {
      const currentTime = new Date().getTime();
      const endTime = new Date(endDate).getTime();
      return endTime > currentTime;
    }
    watchEffect(() => {
      if (applicationReady.value && brandInfoConfigPermission.value) {
        // 应用准备完毕
        nextTick(() => {
          // 登录成功
          const isLoginSuccess = localStorage.getItem('wp_loginSuccess') === '1';
          // 是否近15天之内
          const isRange = inTimeRange(new Date(2023, 2, 24, 23, 59, 59, 999));
          if (isLoginSuccess && isRange) {
            // 触发品牌信息指南
            openBrandInfoMenu();
          }
        });
      }
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      return guideStatus.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "rect",
        style: _normalizeStyle({
          left: guideInfo.rect.left + 'px',
          top: guideInfo.rect.top + 'px',
          width: guideInfo.rect.width + 'px',
          height: guideInfo.rect.height + 'px'
        })
      }, null, 4), _createElementVNode("div", {
        class: "guide-content",
        style: _normalizeStyle({
          left: guideInfo.x + 'px',
          top: guideInfo.y + 'px'
        })
      }, [_createElementVNode("p", null, _toDisplayString(guideInfo.text), 1), _createElementVNode("div", {
        class: "next-btn",
        onClick: nextStep
      }, [_createElementVNode("span", null, _toDisplayString(guideInfo.btnText), 1)]), _hoisted_2], 4), _createElementVNode("div", {
        class: "close-btn",
        title: "关闭",
        onClick: closeEvent
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(CircleClose))]),
        _: 1
      })])])) : _createCommentVNode("", true);
    };
  }
};